import { render } from "./CircleSpinner.vue?vue&type=template&id=5172ad0b&scoped=true"
import script from "./CircleSpinner.vue?vue&type=script&lang=js"
export * from "./CircleSpinner.vue?vue&type=script&lang=js"

import "./CircleSpinner.vue?vue&type=style&index=0&id=5172ad0b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5172ad0b"]])

export default __exports__